// Shared pulsing placeholder primitive for marketing-site loading states -
// composed via className for each shape needed (see featured-campaign-skeleton.tsx
// and testimonials-skeleton.tsx for usage).
export default function SkeletonBlock({
  className = ''
}: { className?: string }) {

  return <div className={`animate-pulse bg-gray-100 dark:bg-gray-800 rounded-lg ${ className }`} />;
}
